module.exports = __webpack_public_path__ + "static/media/slide-image-4-small-min-new.2dd04077.jpg";